import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslocoPipe } from '@jsverse/transloco';
import { DriverscamVideoMinimumInfo } from '@pcp/core/interfaces';
import { IconButtonDirective } from 'shared/ui/icon-button';
import { DifficultQuestionIconComponent, DriverscamIconComponent } from 'shared/ui/icons';

/**
 * Difficult-question and driverscam buttons of the beamer nav. `display: contents`: the buttons are items of
 * the layout's `.actions` column. Pure UI: the layout handles the outputs.
 * Styles: libs/styles/slide-sync/beamer-navigation/_nav-parts.scss (global, beamer themes).
 */
@Component({
    selector: 'pcp-nav-action-buttons',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIconButton, MatTooltip, IconButtonDirective, DifficultQuestionIconComponent, DriverscamIconComponent, TranslocoPipe],
    template: `
        @let questionNumbers = difficultQuestionNumbers();
        @if (questionNumbers) {
            <button
                (click)="difficultQuestionIndicatorClicked.emit(questionNumbers)"
                pcp-ui-icon-button size="large"
                class="difficult-question"
                mat-icon-button
                [matTooltip]="'icon-button.difficultquestions' | transloco"
            >
                <pcp-ui-difficult-question-icon [size]="'100%'" class="thumb-icon"></pcp-ui-difficult-question-icon>
            </button>
        }
        @let driverscamVideo = assignedDriverscamVideo();
        @if (driverscamVideo) {
            <button
                mat-icon-button
                pcp-ui-icon-button size="large"
                class="driverscam"
                (click)="driverscamAssignmentClicked.emit(driverscamVideo)"
                [matTooltip]="driverscamVideo.name"
            >
                <pcp-ui-driverscam-icon [size]="'100%'" class="thumb-icon"></pcp-ui-driverscam-icon>
            </button>
        }
    `,
})
export class NavActionButtonsComponent {
    /** Difficult question numbers of the current slide; a button is shown when set. */
    readonly difficultQuestionNumbers = input<string[] | undefined>(undefined);
    /** Driverscam video assigned to the current slide; a button is shown when set. */
    readonly assignedDriverscamVideo = input<DriverscamVideoMinimumInfo | undefined>(undefined);

    readonly difficultQuestionIndicatorClicked = output<string[]>();
    readonly driverscamAssignmentClicked = output<DriverscamVideoMinimumInfo>();
}
